














import { createComponent } from "@vue/composition-api";
import { BaseDrinkInfo } from "@web-components";
/* eslint-disable */
import { getDrinkDescriptions } from "@dcc/constants/drinkConstants";
import { DrinkingDay } from "../types/drinkingDay";
/* eslint-enable */
export default createComponent({
  components: {
    BaseDrinkInfo
  },
  props: {
    unitAmounts: {
      type: Object as () => DrinkingDay,
      required: true
    }
  },
  setup() {
    const drinkDescriptions = getDrinkDescriptions();
    return {
      drinkDescriptions
    };
  }
});
